// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items__container[data-v-7402047f] {\n  display: block;\n}\n.item__container[data-v-7402047f] {\n  display: inline-block;\n  background-color: white;\n  margin: 5px;\n  padding: 4px 8px;\n  border: 1px solid #d6ddd9;\n  border-radius: 20px;\n  margin-left: 0;\n}\n[data-v-7402047f] i.fa-hand-holding {\n  margin-top: 0 !important;\n  display: block !important;\n}", ""]);
// Exports
module.exports = exports;
